import { Button, Card, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { PatientProps } from "../PatientList";
import { useState } from "react";
import { ARCHIVED_ON, ARCHIVED_REASON, PATIENT, PATIENT_ARCHIVE } from "../../util/const";
import PatientDisplay from "../../Components/PatientDisplay";
import { FormatDateForDisplay } from "../../util/data-utils";
import { IconButton, Tooltip } from "@mui/material";
import { UnarchiveOutlined } from "@mui/icons-material";
import { Patient } from "../../types/patient";
import { DatabaseManager } from "../../services/DatabaseManager";
import LoadingSpinner from "../../Components/LoadingSpinner";


const ArchivedPatients = (props: PatientProps) => {

  const [activatePatient, setActivatePatient] = useState<Patient | undefined>();

  const [search, setSearch] = useState("");
  const onSearchInputChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);
  };

  const onActivateConfirmClicked = async () => {

    if(activatePatient === undefined)
      return;

    activatePatient!.isActive = true;
    await DatabaseManager.getInstance().put(PATIENT_ARCHIVE, activatePatient!)
    .then((response) => {
      props.refreshData(true).then( 
        (value) => {
          setActivatePatient(undefined);
        }
      );
    })
    .catch((error) => {
      console.error(error);
    });  
  }
  
  return (
    <>
      <Card className="mt-3 mb-3" border="secondary" text="white">
        <Card.Header className="empty-header app-colour">
        </Card.Header>
        <Card.Body>
          {props.isLoading ? (
            <LoadingSpinner />
          ) : props.patients && props.patients.length > 0 ? (
            <Table striped bordered hover>
              <thead className="table-header">
                <tr>
                  <th colSpan={4}>
                    <Form>
                      <Row>
                        <Col />
                        <Form.Group as={Col} controlId="search">
                          <Form.Control
                            type="text"
                            placeholder="Search..."
                            value={search}
                            onChange={onSearchInputChanged}
                            className="fs-6"
                          />
                        </Form.Group>
                        <Col />
                      </Row>
                    </Form>
                  </th>
                </tr>
                <tr>
                  <th></th>
                  <th className="lge-col left">{PATIENT}</th>
                  <th className="med-col centre">{ARCHIVED_ON}</th>
                  <th className="left">{ARCHIVED_REASON}</th>
                </tr>
              </thead>
              <tbody>
                {props.patients.map((patient, i) => {
                  if (
                    search === "" ||
                    patient.givenNames.toString().toLowerCase().includes(search.toLowerCase()) ||
                    patient.familyName.toLowerCase().includes(search.toLowerCase()) ||
                    patient.urn.includes(search) ||
                    patient.birthDate.toString().includes(search)
                  ) {
                    return (
                      <tr key={i} className="middle">
                        <td className="small-col centre"><Tooltip title="Activate">
                          <IconButton onClick={(e) => setActivatePatient(patient) }>
                            <UnarchiveOutlined sx={{color:"#78909C"}} />
                          </IconButton>
                        </Tooltip>
                        </td>
                        <td><PatientDisplay patient={patient} /></td>
                        <td className="centre">{FormatDateForDisplay(patient.archivedOn)}</td>
                        <td className="left">{patient.archivedReason}</td>
                      </tr>
                    );
                  }
                  return <></>;
                })}
              </tbody>
            </Table>
          ) : (
            <div>No Archived Patients </div>
          )}
          <Modal
            show={activatePatient !== undefined}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>Activate Patient</Modal.Title>
            </Modal.Header>
            <Modal.Body className="fs-6">
              {activatePatient?.givenNames} {activatePatient?.familyName} 
              <div className="mt-2"> Born: {FormatDateForDisplay(activatePatient?.birthDate)} URN: {activatePatient?.urn}</div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={(e) => setActivatePatient(undefined) }>
                Cancel
              </Button>
              <Button className="fs-6 btn-color" onClick={(e) => onActivateConfirmClicked()} >Confirm</Button>
            </Modal.Footer>
          </Modal>
        </Card.Body>
      </Card>
    </>
  );
}

export default ArchivedPatients;